export function isMobile() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '767px';

  try {
    return window.matchMedia("only screen and (max-width: ".concat(maxWidth, ")")).matches;
  } catch (e) {
    return false;
  }
}